module.exports = __webpack_public_path__ + "img/home_header_bg.11f2d4da.png";